import { Injectable } from '@angular/core';
import {
  BusinessUnit,
  BusinessUnitTypeahead
} from '../models/business-unit.model';

@Injectable ( {
  providedIn: 'root'
} )
export class HelperService {

  readonly controlDelimiter = '___';

  constructor () {
  }

  fieldName ( key: string, sequence = 0 ) {
    return `${ key }${ this.controlDelimiter }${ sequence }`;
  }

  transformToBuSearchTypeahead ( model: BusinessUnit | BusinessUnit[] ): BusinessUnitTypeahead | BusinessUnitTypeahead[] | any {
    if ( model && Array.isArray ( model ) ) {
      const transformed = model.map ( e => {
        return this.businessUnitTypeaheadTransformed ( e );
      } );
      return transformed;
    }
    if ( typeof model === 'undefined' ) {
      return undefined;
    } else if ( !Array.isArray ( model ) && model ) {
      return this.businessUnitTypeaheadTransformed ( model );
    }
  }

  private businessUnitTypeaheadTransformed = ( model: BusinessUnit ): BusinessUnitTypeahead => {
    const addressSegments: string[] = [];
    if ( model.address1 ) {
      addressSegments.push ( String ( model.address1 ).trim () );
    }
    if ( model.address2 ) {
      addressSegments.push ( String ( model.address2 ).trim () );
    }

    const city = model.city ? String ( model.city ).trim () : '';
    const jurisdictionPrefix = model.jurisdiction ? String ( model.jurisdiction ).split ( '_' )[ 0 ] : '';
    const postal = model.postalCode ? String ( model.postalCode ).trim () : '';

    let localityStr = '';
    if ( city && jurisdictionPrefix ) {
      localityStr = `${ city }, ${ jurisdictionPrefix }`;
    } else if ( city ) {
      localityStr = city;
    } else if ( jurisdictionPrefix ) {
      localityStr = jurisdictionPrefix;
    }
    if ( postal ) {
      localityStr = localityStr ? `${ localityStr } ${ postal }` : postal;
    }

    const addressParts: string[] = [];
    if ( addressSegments.length ) {
      addressParts.push ( addressSegments.join ( ', ' ) );
    }
    if ( localityStr ) {
      addressParts.push ( localityStr );
    }
    const addressStr = addressParts.length ? addressParts.join ( ', ' ) : '';

    const location_code = model.referenceNumber ?? '';
    const phone = model.phone ?? '';

    const formattedDetails = [
      `Location Code: ${ location_code }`,
      addressStr ? `Address: ${ addressStr }` : undefined,
      phone ? `Phone: ${ phone }` : undefined
    ].filter ( Boolean ).join ( '; ' );

    return {
      id: model.id,
      displayName: model && model.displayName ? model.displayName : model.name,
      location_code,
      address: addressStr,
      phone,
      formattedDetails,
      ...model
    } as any;
  }

}
